import React from 'react';
import { range } from 'lodash';

import textNodes from 'domains/text_nodes/';

type TextToolsFontSizeProps = {
  autofit: boolean;
  size: number;
  autofitCheck: (checked: boolean) => void;
  sizeChange: (size: number) => void;
};

const sizes = range(textNodes.utils.fontMinSize, textNodes.utils.fontMaxSize + 1);

function TextToolbarSidebarFontSize(props: TextToolsFontSizeProps) {
  const { autofit, size, autofitCheck, sizeChange } = props;

  function handleCheckboxClick({ target: { checked } }: React.ChangeEvent<HTMLInputElement>) {
    autofitCheck(checked);
  }

  function handleSizeChange(e: React.ChangeEvent<HTMLSelectElement>) {
    const sizeStr = e.target.value;
    sizeChange(parseInt(sizeStr));
  }

  return (
    <div className="texttools-item__text-node font-size">
      <label className="check-autofit">
        <input type="checkbox" onChange={handleCheckboxClick} checked={autofit} />
        <span>Fit text to space</span>
      </label>
      <label className="select-size">
        Font Size
        <select
          disabled={autofit}
          onClick={(e) => e.stopPropagation()}
          onChange={handleSizeChange}
          value={size}
        >
          {sizes.map((item) => (
            <option
              key={item}
              value={item}
              className={`texttools__dropdown-item ${
                item === size ? 'texttools__dropdown-item--selected' : ''
              }`}
            >
              {item}
            </option>
          ))}
        </select>
      </label>
    </div>
  );
}

export default TextToolbarSidebarFontSize;
